// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import DiffFilledSvg from "@fishx/icons-svg/es/asn/DiffFilled";
import FishxIcon from '../components/FishxIcon';

var DiffFilled = function DiffFilled(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: DiffFilledSvg
  }));
};

DiffFilled.displayName = 'DiffFilled';
export default React.forwardRef(DiffFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/DiffFilled.js
// module id = 2414
// module chunks = 0